var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "#F07272"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.41 13.42H10.8C10.8 13.0467 10.884 12.6967 11.052 12.37C11.22 12.034 11.4253 11.7493 11.668 11.516C11.9107 11.2733 12.1533 11.0447 12.396 10.83C12.6387 10.606 12.844 10.3633 13.012 10.102C13.18 9.84067 13.264 9.57467 13.264 9.304C13.264 8.92133 13.1287 8.62267 12.858 8.408C12.5873 8.19333 12.2233 8.086 11.766 8.086C11.3273 8.086 10.9493 8.198 10.632 8.422C10.3147 8.646 10.086 8.96333 9.946 9.374L8.56 8.59C8.812 7.93667 9.22733 7.428 9.806 7.064C10.394 6.7 11.0613 6.518 11.808 6.518C12.648 6.518 13.3667 6.756 13.964 7.232C14.5707 7.708 14.874 8.366 14.874 9.206C14.874 9.58867 14.79 9.95267 14.622 10.298C14.454 10.6433 14.2487 10.9373 14.006 11.18C13.7633 11.4227 13.5207 11.6607 13.278 11.894C13.0353 12.118 12.83 12.3607 12.662 12.622C12.494 12.8833 12.41 13.1493 12.41 13.42ZM11.612 14.568C11.9013 14.568 12.1487 14.6707 12.354 14.876C12.5593 15.0813 12.662 15.3287 12.662 15.618C12.662 15.9073 12.5593 16.1547 12.354 16.36C12.1487 16.5653 11.9013 16.668 11.612 16.668C11.3227 16.668 11.0753 16.5653 10.87 16.36C10.6647 16.1547 10.562 15.9073 10.562 15.618C10.562 15.3287 10.66 15.0813 10.856 14.876C11.0613 14.6707 11.3133 14.568 11.612 14.568Z",
    fill: "#F07272"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarHelp);
export default __webpack_public_path__ + "static/media/sidebar-help.d9d623e717c5bc394a4c6628fad7a801.svg";
export { ForwardRef as ReactComponent };